module.exports = "https://web-assets-production.autolist.com/_next/static/images/guides-and-reviews-hero-6ce2ef3ff639afaaedb8158f2a99c6d2.png";